import {
    Card,
    CardContent,
    Grid,
    IconButton,
    Container,
    Dialog,
    DialogTitle,
    Divider,
    Input,
    Typography
} from '@mui/material'
import { Formik } from 'formik'
import React, { useState } from 'react'
import { Close, Folder } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'

function ImportDialog({
    initialValue,
    visible,
    onClose,
    outlet,
    onImport,
    fileVerification,
    fileStatusIconCG,
    fileStatusIconC,
    fileStatusIconItem,
    selectedFolder,
    counterGroupFile,
    counterFile,
    itemFile,
    backButtonDisabled,
    submitButtonDisabled
}) {


    if (initialValue == undefined)
        initialValue = {
            name: '',
            sku: '',
            kitchen_counter_id: '',
            itemlist: [],
            delete_status: false,
            parcel_amt: 0,
            unit: "PCS",
            price: [
                {
                    unit_price: 0,
                    igst: 0,
                    cgst: 0,
                    sgst: 0,
                    cess1: 0,
                    cess2: 0,
                    cost_price: 0,
                    discount_percentage: 0,
                    discount_value: 0,
                    price_id: 1,
                },
                {
                    unit_price: 0,
                    igst: 0,
                    cgst: 0,
                    sgst: 0,
                    cess1: 0,
                    cess2: 0,
                    cost_price: 0,
                    discount_percentage: 0,
                    discount_value: 0,
                    price_id: 2,
                },
                {
                    unit_price: 0,
                    igst: 0,
                    cgst: 0,
                    sgst: 0,
                    cess1: 0,
                    cess2: 0,
                    cost_price: 0,
                    discount_percentage: 0,
                    discount_value: 0,
                    price_id: 3,
                },
            ],
        }

    const handleSnackbarClose = () => {
        setSnackBar(false)
    }

    if (outlet === null || outlet === undefined)
        outlet = ""


    const handleSubmit = async (value, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onImport()
        onClose()
    }

    const [selectedFolderIcon, setSelectedFolderIcon] = useState(<Folder fontSize='small' color='primary' />)

    const handleFolderSelect = (event) => {
        fileVerification(event)
    }

    return (
        <div>
            <Dialog maxWidth={'sm'} fullWidth anchor="right" backdrop="static" variant="temporary" open={visible}>
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    Import Files
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        onSubmit={handleSubmit}
                        initialValues={initialValue}
                    >
                        {({
                            handleSubmit,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card >
                                    <CardContent>
                                        <Grid container spacing={5} style={{ paddingTop: 10, paddingLeft: 10 }}>
                                            <div>
                                                <Input
                                                    type="file"
                                                    inputProps={{
                                                        webkitdirectory: 'true',
                                                        directory: 'true',
                                                        multiple: false
                                                    }}
                                                    disableUnderline={true}
                                                    onChange={handleFolderSelect}
                                                />
                                                {selectedFolder && <Grid container sx={{ paddingTop: 5, pb: 5 }}><Grid item sx={{ marginRight: 1 }}><Typography variant='subtitle1'>Selected folder :  {selectedFolder}</Typography></Grid><Grid item sx={{ alignItems: 'center' }}><Typography variant='subtitle1'>{selectedFolderIcon}</Typography></Grid></Grid>}
                                                {counterGroupFile && <Grid container sx={{ justifyContent: "space-between" }}><Grid item><Typography fontWeight={'bold'} variant='subtitle1'>{counterGroupFile}</Typography></Grid><Grid item><Typography variant='subtitle1'>{fileStatusIconCG}</Typography></Grid></Grid>}
                                                {counterFile && <Grid container sx={{ justifyContent: "space-between" }}><Grid item ><Typography fontWeight={'bold'} variant='subtitle1'>{counterFile}</Typography></Grid><Grid item><Typography variant='subtitle1'>{fileStatusIconC}</Typography></Grid></Grid>}
                                                {itemFile && <Grid container sx={{ justifyContent: "space-between" }}><Grid item ><Typography fontWeight={'bold'} variant='subtitle1'>{itemFile}</Typography></Grid><Grid item><Typography variant='subtitle1'>{fileStatusIconItem}</Typography></Grid></Grid>}
                                            </div>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item>
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8} disabled={submitButtonDisabled} >
                                            Import
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog >
        </div >
    )
}

export default ImportDialog
